/* global _ */
import Vue from 'vue'

/***
 *shown
 * div(v-reddot="{key: 'test', right: '10px', top: '4px'}") 
 *not shown
 * div(v-reddot="{}")
 */
Vue.directive('reddot', {
  inserted (el, binding) {
    if (_.isEmpty(binding.value)) return
    el.style.position = 'relative'
    const newIcon = document.createElement('i')
    newIcon.style.position = 'absolute'
    newIcon.style.right = binding.value.right || '4px'
    newIcon.style.top = binding.value.top || '4px'
    newIcon.style.border = '4px solid red'
    newIcon.style.borderRadius = '100%'
    /* eslint-disable */
    if (_.has(localStorage, `__fx_reddot_showed_${binding.value.key}`) &&
      localStorage[`__fx_reddot_showed_${binding.value.key}`]) {

    } else {
      el.appendChild(newIcon)
      el.addEventListener('click', (e) => {
        if (e.currentTarget.contains(newIcon)) {
          localStorage[`__fx_reddot_showed_${binding.value.key}`] = true
          e.currentTarget.removeChild(newIcon)
        }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/script/directive.js